<script>
  import { Route, useNavigate } from "svelte-navigator";
  import { useUrlParams } from "@stores/urlStore.js";
  import { POTENTIAL_SCOPE_SUBROUTES, ROUTES } from "@utils/routes.js";

  import Dashboard from "./Dashboard.svelte";
  import SuggestionBox from "./SuggestionBox.svelte";
  import TaskOverview from "./TaskOverview.svelte";
  import ManageInvitations from "./ManageInvitations.svelte";

  const urlParams = useUrlParams();
  const navigate = useNavigate();

  let redirected = false;

  $: ({ survey } = $urlParams);
  $: hasRequiredParams = Boolean($urlParams.survey);
  $: if (!hasRequiredParams && !redirected) {
    redirected = true;
    Promise.resolve(navigate(ROUTES.knex.root, { replace: true })).catch(() => {
      window.location.replace(ROUTES.knex.root);
    });
  }
</script>

{#if hasRequiredParams}
  <div style="height:100%">
    <Route path={POTENTIAL_SCOPE_SUBROUTES.dashboard}><Dashboard /></Route>
    <Route path={POTENTIAL_SCOPE_SUBROUTES.manageInvitations}
      ><ManageInvitations {survey} /></Route
    >
    <Route path={POTENTIAL_SCOPE_SUBROUTES.taskOverview}
      ><TaskOverview {survey} /></Route
    >
    <Route path={POTENTIAL_SCOPE_SUBROUTES.surveyDetail}
      ><TaskOverview {survey} detailMode /></Route
    >
    <Route path={POTENTIAL_SCOPE_SUBROUTES.suggestionBox}
      ><SuggestionBox {survey} /></Route
    >
  </div>
{/if}
